import ApiClient from './ApiClient';

class BillingClient extends ApiClient {
  constructor(url) {
    super(url ? `${url}` : '');
  }

  async downloadInvoice(invoice, displayName) {
    try {
      const res = await this.get(`invoice/${invoice.id}`, {
        responseType: 'blob',
        headers: { Accept: 'application/pdf' }
      });
      const blob = new Blob([res.data], { type: 'application/pdf' });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `${invoice.invoiceReference}-${displayName}.pdf`;
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      throw new Error(`Failed to get invoice #${invoice.id}: ${error.message}`);
    }
  }

  async getInvoices() {
    try {
      const data = await this.get('tenant/invoice');
      return data;
    } catch (error) {
      throw new Error(`Failed to get invoices: ${error.message}`);
    }
  }

  async getOrders() {
    try {
      const data = await this.get('/orders');
      return data;
    } catch (error) {
      throw new Error(`Failed to get orders: ${error.message}`);
    }
  }
}

export default BillingClient;
